

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    }
  },
  mounted() {
    this.listApi();
  },
  data() {
    return {
      localIsVisible: this.isVisible,
      userList: [],
    };
  },
  methods: {

    closePopup() {
      this.localIsVisible = false;
      this.$emit('liveClose', false);
    },

    async listApi() {
      const response = await this.$axios.get("/api/presence-get/11");

      if (response.data.result == true) {
        this.userList = response.data.data
      }

    },

    // blackListConnect() {
    //   if (!window.Pusher)
    //     window.Pusher = Pusher;
    //   if (!this.echo) {
    //     this.echo = new Echo({
    //       broadcaster: "pusher",
    //       key: "668bac10cc6db3a1338c",
    //       cluster: "ap3",
    //       authEndpoint: '/api/messages',
    //     });
    //   }
    //   this.echo.channel(`chats` + this.$route.query.groupId)
    //     .listen("JoinMessage", (e) => {
    //       console.log(e);
    //       if (e.group.message_type == 1) {
    //         this.$emit('messageDelete', e);
    //       }

    //     })
    // },

  },

};
